// extracted by mini-css-extract-plugin
module.exports = {"container":"_1rQ20z MzH6Iw mz-default-dark-font","nav":"mr9gCa mz-mob-screen__nav","nav__title":"EJVWZ_","nav__button":"zTDTwG","nav__backIcon":"_1Fnvlc","content":"xSJ5p-"};